/* Cœur à Offrir — scripts du thème */
(function () {
  'use strict';

  /* --- Menu mobile & recherche ------------------------------------------ */
  function bindToggle(triggerSelector, targetSelector) {
    document.querySelectorAll(triggerSelector).forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var target = document.querySelector(targetSelector);
        if (!target) return;
        var isOpen = target.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          var input = target.querySelector('input[type="search"], input[type="text"]');
          if (input) input.focus();
        }
      });
    });
  }

  bindToggle('[data-menu-toggle]', '[data-mobile-menu]');
  bindToggle('[data-search-toggle]', '[data-header-search]');

  /* --- Carrousels -------------------------------------------------------- */
  document.querySelectorAll('[data-carousel-wrapper]').forEach(function (wrapper) {
    var track = wrapper.querySelector('[data-carousel]');
    var dotsHolder = wrapper.querySelector('[data-carousel-dots]');
    if (!track || !dotsHolder) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;

    function perView() {
      var first = slides[0].getBoundingClientRect().width;
      if (!first) return 1;
      return Math.max(1, Math.round(track.clientWidth / first));
    }

    function build() {
      var pages = Math.ceil(slides.length / perView());
      dotsHolder.innerHTML = '';
      if (pages <= 1) {
        dotsHolder.style.display = 'none';
        return;
      }
      dotsHolder.style.display = '';
      for (var i = 0; i < pages; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Aller à la page ' + (index + 1));
          dot.addEventListener('click', function () {
            var target = slides[Math.min(index * perView(), slides.length - 1)];
            track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          dotsHolder.appendChild(dot);
        })(i);
      }
      sync();
    }

    function sync() {
      var dots = dotsHolder.children;
      if (!dots.length) return;
      var index = Math.round(track.scrollLeft / (track.clientWidth || 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === Math.min(index, dots.length - 1));
      }
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(sync, 80);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(build, 200);
    });

    build();
  });

  /* --- Sélecteur de quantité --------------------------------------------- */
  document.querySelectorAll('[data-quantity]').forEach(function (widget) {
    var input = widget.querySelector('input');
    widget.querySelectorAll('button').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = button.dataset.change === 'down' ? -1 : 1;
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(parseInt(input.min, 10) || 1, value + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* --- Galerie produit ---------------------------------------------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.full;
        main.srcset = '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
          other.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  /* --- Variantes produit -------------------------------------------------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form');
    if (!form) return;

    var variantsScript = picker.querySelector('[data-variants-json]');
    if (!variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return;
    }

    var idInput = form.querySelector('[name="id"]');
    var priceHolder = document.querySelector('[data-variant-price]');
    var submit = form.querySelector('[data-add-button]');

    function selectedOptions() {
      return Array.prototype.map.call(picker.querySelectorAll('select'), function (select) {
        return select.value;
      });
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.filter(function (variant) {
        return variant.options.every(function (option, index) {
          return option === chosen[index];
        });
      })[0];

      if (!match) {
        if (submit) {
          submit.setAttribute('aria-disabled', 'true');
          submit.disabled = true;
          submit.textContent = submit.dataset.unavailable || 'Indisponible';
        }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceHolder && match.price_html) priceHolder.innerHTML = match.price_html;

      if (submit) {
        submit.disabled = !match.available;
        submit.setAttribute('aria-disabled', match.available ? 'false' : 'true');
        submit.textContent = match.available
          ? submit.dataset.available || 'Ajouter au panier'
          : submit.dataset.soldOut || 'Rupture de stock';
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', update);
    });
  });
})();
